import React, { useContext, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import CustomActionMenu from "@components/CustomActionMenu/CustomActionMenu";
import CustomHeader from "@components/CustomHeader/CustomHeader";
import CustomTable from "@components/CustomTable/CustomTable";
import Loader from "@components/Loader/Loader";
import { CreateModalContext } from "layouts/appLayout/layout";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGetCRAByValidateurPendingQuery } from "store/cra/cra.api";

// Crée un modal similaire à LeaveRequestModal
import ReactPaginate from "react-paginate";

const CRAListPage = () => {
  const { t } = useTranslation();
  const { toggleCreateModal } = useContext(CreateModalContext);
  const currentUser = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  const [openMenuId, setOpenMenuId] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 5;

  const { data: craList, isLoading } = useGetCRAByValidateurPendingQuery(
    currentUser._id
  );

  const headers = [
    { key: "month", label: t("cra.month") },
    { key: "year", label: t("cra.year") },
    { key: "totalProduction", label: t("cra.totalProduction") },
    { key: "totalAbsences", label: t("cra.totalAbsences") },
    { key: "status", label: t("cra.status") },
    { key: "createdAt", label: t("cra.createdAt") },
    { key: "collaborator", label: t("cra.collaborator") },
  ];

  const renderCell = (key, cra) => {
    if (key === "month") return cra.month;
    if (key === "year") return cra.year;
    if (key === "totalProduction") return cra.totalProduction;
    if (key === "totalAbsences") return cra.totalAbsences;
    if (key === "collaborator") return cra.collaborator?.name || "-";
    if (key === "status")
      return cra.status === "pending_validation"
        ? t("cra.pending")
        : t("cra.validated");
    if (key === "createdAt")
      return new Date(cra.createdAt).toLocaleDateString();
    return cra[key];
  };

  const handleConsult = (cra) => {
    setOpenMenuId(null);
    toggleCreateModal(t("cra.title_edit"));
  };

  const actionMenu = (cra) => {
    const actions = [
      {
        label: t("cra.actions.view"),
        onClick: () => navigate(`/validation/${cra._id}`),
      },
    ].filter(Boolean);

    return (
      <CustomActionMenu
        openMenuId={openMenuId}
        setOpenMenuId={setOpenMenuId}
        data={cra}
        actions={actions}
      />
    );
  };

  const onSearchCRA = (text) => {
    setSearchText(text.toLowerCase());
    setCurrentPage(0); // reset pagination sur recherche
  };

  const filteredCRA = useMemo(() => {
    if (!craList?.data?.data) return [];
    if (searchText.length <= 1) return craList.data?.data;

    return craList.data?.data.filter((c) => {
      return (
        c.commentaire?.toLowerCase().includes(searchText) ||
        c.status?.toLowerCase().includes(searchText)
      );
    });
  }, [craList?.data?.data, searchText]);

  // ✅ Pagination
  const pageCount = Math.ceil(filteredCRA.length / itemsPerPage);
  const offset = currentPage * itemsPerPage;
  const currentItems = filteredCRA.slice(offset, offset + itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  if (isLoading) return <Loader />;

  return (
    <div className="p-5" style={{ overflowX: "auto" }}>
      <CustomHeader
        title={t("cra.header_title")}
        dataLength={filteredCRA.length}
        onSearch={onSearchCRA}
      />
      <CustomTable
        headers={headers}
        data={currentItems}
        rowKey="_id"
        renderCell={renderCell}
        actionMenu={actionMenu}
      />

      {/* ✅ Pagination en bas */}

      <div style={{ display: "flex", justifyContent: "center", marginTop: 24 }}>
        <ReactPaginate
          previousLabel={"←"}
          nextLabel={"→"}
          breakLabel={"..."}
          pageCount={pageCount}
          marginPagesDisplayed={1}
          pageRangeDisplayed={2}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          activeClassName={"active"}
          forcePage={currentPage}
        />
      </div>
    </div>
  );
};

export default CRAListPage;
